import React, { useEffect, useState, useMemo } from "react";
import { Container, Input, Table, FormGroup, Label, Col } from "reactstrap";
import { Formik, Form, Field } from "formik";
import Modal from "react-modal"
import { getCustomStyles } from "../../share/ModalStyle";
import { Loading } from "../../share/loading";
import { useTable, useSortBy, useGlobalFilter, usePagination } from "react-table";
import * as Yup from "yup";
import "../../share/form.css";
import './ProposalStyle.css'
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css'
import { NumberWithCommas } from "../../share/NumberWithCommas";
import { RenderCustomHeader } from "../../share/RenderCustomHeader";
import { ConvertDateToThaiBuddhist } from "../../share/ConvertDateToThaiBuddhist";
import { ConvertDateFormat } from "../../share/ConvertDateFormat";
import { CgClose } from "react-icons/cg";
import { NumericFormat } from 'react-number-format';
import { CustomInputNumeric } from '../../share/CustomInputNumeric'
import Swal from "sweetalert2";
import { AiOutlineCheckCircle, AiOutlineCloseCircle, AiOutlineClockCircle, AiOutlineSave } from "react-icons/ai";
// import { SearchFilter } from "../../share/SearchFilter";
// import CreateTableProposalComponent from "./CreateTableProposalComponent"; 


export function ProposedToTheSubCommittee3EditViewComponent() {
  const user = JSON.parse(localStorage.getItem("userData"))
  const myCustomStyles = getCustomStyles()
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  // console.log("data", data);
  const [meetingDate, setMeetingDate] = useState("")
  const [meetingYear, setMeetingYear] = useState("")
  const [meetingNo, setMeetingNo] = useState("")
  const [meetingYearSelect, setMeetingYearSelect] = useState([])
  const [meetingNoSelect, setMeetingNoSelect] = useState([]);
  const [modalRecordBorrow, setModalRecordBorrow] = useState(false);
  const ToggleModalRecordBorrow = () => setModalRecordBorrow(!modalRecordBorrow)
  const [selectTrainClassId, setSelectTrainClassId] = useState(null)

  // console.log("selectTrainClassId", selectTrainClassId)
  const [selectDetailTrainClassId, setSelectDetailTrainClassId] = useState(null);
  // console.log("selectDetailTrainClassId", selectDetailTrainClassId);
  // console.log("selectDetailTrainClassId", selectDetailTrainClassId);
  // console.log("dataForCheck",dataForCheck)
  const selectOption = [{ id: "0", value: "ไม่อนุมัติ" }, { id: "1", value: "อนุมัติ" }]


  function GetClassId(trainNewClassId) {
    setSelectTrainClassId(trainNewClassId)
    setSelectDetailTrainClassId(data.find((item) => {
      return item.trainNewClassId === trainNewClassId
    }))
    ToggleModalRecordBorrow()
  }
  function useInstance(instance) {
    // console.log("instance", instance);
    const { allColumns } = instance;
    // setDataForCheck(data);
    // setDataForCheck(data);
    let rowSpanHeaders = [];


    allColumns.forEach((column, i) => {
      // console.log("column",column)
      const { id, enableRowSpan } = column;
      // console.log("id",id)
      if (enableRowSpan !== undefined) {
        rowSpanHeaders = [
          ...rowSpanHeaders,
          { id, topCellValue: null, topCellIndex: 0, }
        ];
      }
    });
    // console.log("rowSpanHeaders",rowSpanHeaders)

    Object.assign(instance, { rowSpanHeaders });
  }

  const columns = useMemo(
    () => [

      {
        Header: "ข้อมูลผู้ขอกู้",
        columns: [
          {
            Header: "ลำดับ",
            accessor: 'No',
            id: "No",
            enableRowSpan: true,
            // accessor: (_row, i) => i + 1,
            // Cell: (row) => {
            //   return <div>{Number(row.row.id) + 1}</div>;
            // },
            // accessor: "borrowId",
          },
          {
            Header: "เลขที่คำขอ",
            accessor: "borrowNumber",
            enableRowSpan: true,


          },
          {
            Header: "ผู้ขอกู้",
            accessor: "employee",
            enableRowSpan: true,

          },
          {
            Header: "ประเภท",
            accessor: "borrowType",
            enableRowSpan: true
          },
          {
            Header: "ประเภทกิจการ",
            accessor: "businessType",
            enableRowSpan: true,

          },
          {
            Header: "ทุนจดทะเบียน",
            accessor: "registeredCapital",
            enableRowSpan: true,
            Cell: ({ value }) => (
              <>{value ? NumberWithCommas(value) : "-"}</>
            ),
          },
          {
            Header: "จำนวนลูกจ้างทั้งสิ้น (คน)",
            accessor: "employeeAmount",
            Cell: ({ value }) => {
              // console.log("value",value)
              return (
                <>{value ? NumberWithCommas(Number(value)) : "-"}</>
              )
            },
            enableRowSpan: true,

          },
          {
            Header: "ประเภทการฝึก",
            accessor: "inOutTypeName",
            Cell: ({ value }) => (
              <>{value ? value : "-"}</>
            ),
            enableRowSpan: true,

          },
          {
            Header: "รวมวงเงินที่ขอกู้ (บาท)",
            accessor: "amountLimitTotal",
            Cell: ({ value }) => (
              <>{value ? value : "-"}</>
            ),
            enableRowSpan: true,

          },
          {
            Header: "รวมวงเงินที่ได้รับอนุมัติ (บาท)",
            accessor: "amountApproveTotal",
            Cell: ({ value }) => (
              <>{value ? value : "-"}</>
            ),
            enableRowSpan: true,

          },
          {
            Header: "รวมจำนวนคน",
            accessor: "amountPersonTotal",
            Cell: ({ value }) => (
              <>{value ? value : "-"}</>
            ),
            enableRowSpan: true,

          },
          // amountApproveTotal: borrow.amountApproveTotal,
          // amountLimitTotal: borrow.amountLimitTotal,
          // amountCourseTotal: borrow.amountCourseTotal,
          // amountClassTotal: borrow.amountClassTotal,
          // amountPersonTotal: borrow.amountPersonTotal,
        ]
      },

      {
        Header: "รายละเอียด",
        columns: [
          {
            Header: "หลักสูตรเดิม",
            accessor: "trainCourseId",
            Cell: ({ row, value }) => (
              <>{row.original.courseName}</>
            ),
            enableRowSpan: true

          },
          {
            Header: "หลักสูตรใหม่",
            accessor: "trainCourseNewName",
            Cell: ({ row, value }) => (
              <>{row.original.trainCourseNewName}</>
            ),
            enableRowSpan: true

          },
          {
            Header: "วันที่เริ่มฝึกอบรม (ใหม่)",
            accessor: "newStartDate",
            Cell: ({ row, value }) => (
              <>{row.original.newStartDate ?? "-"}</>
            ),
            enableRowSpan: true

          },
          {
            Header: "วันที่สิ้นสุดฝึกอบรม (ใหม่)",
            accessor: "newEndDate",
            Cell: ({ row, value }) => (
              <>{row.original.newEndDate ?? "-"}</>
            ),
            enableRowSpan: true
          },
          {
            Header: "เลขที่ (ใหม่)",
            accessor: "newAddressNo",
            Cell: ({ row, value }) => (
              <>{row.original.newAddressNo ?? "-"}</>
            ),
            enableRowSpan: true
          },
          {
            Header: "หมู่ (ใหม่)",
            accessor: "newMoo",
            Cell: ({ row, value }) => (
              <>{row.original.newMoo ?? "-"}</>
            ),
            enableRowSpan: true
          },
          {
            Header: "ซอย (ใหม่)",
            accessor: "newSoi",
            Cell: ({ row, value }) => (
              <>{row.original.newSoi ?? "-"}</>
            ),
            enableRowSpan: true
          },
          {
            Header: "จังหวัดการฝึกอบรม (ใหม่)",
            accessor: "newProvinceName",
            Cell: ({ row, value }) => (
              <>{row.original.newProvinceName ?? "-"}</>
            ),
            enableRowSpan: true

          },
          {
            Header: "อำเภอการฝึกอบรม (ใหม่)",
            accessor: "newAmphurName",
            Cell: ({ row, value }) => (
              <>{row.original.newAmphurName ?? "-"}</>
            ),
            enableRowSpan: true

          },
          {
            Header: "ตำบลการฝึกอบรมใหม่ (ใหม่)",
            accessor: "newTumbonName",
            Cell: ({ row, value }) => (
              <>{row.original.newTumbonName ?? "-"}</>
            ),
            enableRowSpan: true

          },
          // {
          //   Header: "ตำบลการฝึกอบรม (ใหม่)",
          //   accessor: "newTumbonName",
          //   Cell: ({ row, value }) => (
          //     <>{row.original.newTumbonName ?? "-"}</>
          //   ),
          //   enableRowSpan: true

          // },


          {
            Header: "สาขาอาชีพ",
            accessor: "occupationTrain",
            enableRowSpan: true,
          },
          {
            Header: "จำนวนรุ่น",
            accessor: "classAmount",
            enableRowSpan: true
          },
          {
            Header: "สถานะ",
            accessor: "approveStatus",
            Cell: ({ row }) => {
              // console.log("row", row);
              const s = row.original.approveStatus;
              const isApproved = String(s) === "1";
              const isPending = s === null || s === undefined || s === "";
              if (isApproved) {
                return (
                  <span className="status-badge" style={{ background: "#E8F6EE", color: "#0F8A5F" }}>
                    <AiOutlineCheckCircle size={18} />
                    อนุมัติแล้ว
                  </span>
                );
              }
              if (isPending) {
                return (
                  <div className="d-flex flex-wrap justify-content-center align-items-center">
                    <span className="status-badge" style={{ background: "#FFF6E5", color: "#B26A00" }}>
                      <AiOutlineClockCircle size={18} />
                      รอการอนุมัติ
                    </span>

                    <button
                      type="button"
                      className="my-3 btn-green mx-2"
                      onClick={() => GetClassId(row.original.trainNewClassId)}
                    >
                      บันทึกผลการพิจารณา
                    </button>
                  </div>


                );
              }
              return (
                <span className="status-badge" style={{ background: "#FDECEC", color: "#B42318" }}>
                  <AiOutlineCloseCircle size={18} />
                  ไม่อนุมัติ
                </span>
              );
            },
          },



        ]
      },
      {
        Header: "หน่วยงานที่รับคำขอกู้ยืม",
        accessor: "site",
        enableRowSpan: true
      }

    ],
    [data]
  );

  useEffect(() => {
    GetBorrowThree()
  }, [meetingNo, meetingYear, meetingDate])

  async function GetBorrowThree() {
    setLoading(true)
    try {
      let res = await fetch(`api/ProposalBorrow/getResultProposalTrainForEdit/${meetingNo}/${meetingYear}/${meetingDate}`);
      let resJson = await res.json();
      let newData = [];
      // console.log("resJson", resJson.dataenum)
      await resJson.dataenum?.forEach((borrow, index) => {
        borrow.courseTrains?.forEach((course) => {
          newData.push({
            No: index + 1,
            borrowId: borrow.borrowId,
            borrowNumber: borrow.borrowNumber,
            employee: borrow.employee,
            borrowType: borrow.borrowType,
            businessType: borrow.businessType,
            registeredCapital: borrow.registeredCapital,
            employeeAmount: borrow.employeeAmount,
            name: borrow.name,
            position: borrow.position,
            site: borrow.site,
            trainCourseId: course.trainCourseId,
            approveStatus: course.approveStatus,
            courseName: course.courseName,
            trainCourseNewName: course.trainCourseNewName,
            inOutTypeName: course.inOutTypeName,
            trainingTypeName: course.trainingTypeName,
            occupationTrain: course.occupationTrain,
            classAmount: course.classAmount,
            trainNewClassId: course.trainNewClassId,
            amountApproveTotal: borrow.amountApproveTotal,
            amountLimitTotal: borrow.amountLimitTotal,
            amountCourseTotal: borrow.amountCourseTotal,
            amountClassTotal: borrow.amountClassTotal,
            amountPersonTotal: borrow.amountPersonTotal,

            //เพิ่มที่อยู่ที่เปลี่ยนแปลง
            newAddressNo: course.newAddressNo,
            newSoi: course.newSoi,
            newMoo: course.newMoo,
            newStreet: course.newStreet,
            newProvinceName: course.newProvinceName,
            newAmphurName: course.newAmphurName,
            newTunbonName: course.newTunbonName,
            newPostCode: course.newPostCode,
            newPhone: course.newPhone,
            newEmail: course.newEmail,
            newMobile: course.newMobile,
            newFax: course.newFax,
            newStartDate: course.newStartDate,
            newEndDate: course.newEndDate,

          })
        })
      })
      setData(newData)
    } catch (e) {
      // console.log("err =>", e)
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    async function GetMeetingForSelect() {
      setLoading(true)
      try {
        let res = await fetch(`api/ProposalBorrow/getMeetingNoSelect`);
        let resJson = await res.json();
        setMeetingNoSelect(resJson.dataenum);
      } catch (e) {
        // console.log("err =>", e)
      } finally {
        setLoading(false)
      }
    }
    GetMeetingForSelect()

  }, [])

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    rowSpanHeaders,

    page,
    // nextPage,
    // previousPage,
    // canNextPage,
    // canPreviousPage,
    // pageOptions,
    // gotoPage,
    // pageCount,
    setPageSize,
    state,
    // setGlobalFilter
  } = useTable({
    columns,
    data
  },
    (hooks) => { hooks.useInstance.push(useInstance) },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const { globalFilter, pageIndex, pageSize } = state

  const fromInitialValues = {
    meetingNo: "",
    meetingYear: "",
    meetingDate: ""
  }

  const recordBorrowInititalValue = {
    borrowId: selectDetailTrainClassId?.borrowId ?? "",
    trainNewClassId: selectTrainClassId,
    // amount: selectDetailTrainClassId?.payment ?? "",
    approveStatus: selectDetailTrainClassId?.statusApprove ?? "",
    // approveAmount: selectDetailTrainClassId?.amountApprove ? selectDetailTrainClassId?.amountApprove : "",
    // rejectRemark: selectDetailTrainClassId?.rejectRemark ?? ""
  }
  const recordBorrowValidationSchema = Yup.object().shape({
    approveStatus: Yup.string().oneOf(["0", "1"]).required("กรุณาระบุ"),
    // approveAmount: Yup.string().when("approveStatus", {
    //   is: "1",
    //   then: Yup.string().required("กรุณาระบุจำนวนเงิน"),
    // }),
    // rejectRemark: Yup.string().when("approveStatus", {
    //   is: "2",
    //   then: Yup.string().trim().required("กรุณาระบุสาเหตุที่ไม่อนุมัติ"),
    //   otherwise: Yup.string().nullable(),
    // }),
  })

  const recordBorrowOnsubmit = async (values, actions) => {
    // console.log("values", values);
    let formData = new FormData();
    formData.append("trainNewClassId", values.trainNewClassId);
    formData.append("approveStatus", values.approveStatus);

    try {
      let res = await fetch("api/ProposalBorrow/recordChangeTrainNewCourse", {
        method: "POST",
        headers: {
          // "Content-type": "application/json",
          "token": user?.token || "",
        },
        body: formData
      })
      let resJson = await res.json();
      if (resJson.status === 1) {
        Swal.fire({
          icon: "success",
          title: "บันทึกข้อมูลสำเร็จ",
          confirmButtonColor: "#0A66C2",
          confirmButtonText: "ตกลง",
        }).then(async (result) => {
          if (result.isConfirmed) {
            await GetBorrowThree()
            ToggleModalRecordBorrow()
            setSelectDetailTrainClassId(null)
          }
        })
      } else {
        Swal.fire({
          icon: "error",
          title: "มีบางอย่างผิดปกติ",
          confirmButtonColor: "#0A66C2",
          confirmButtonText: "ตกลง",
        })
      }
      GetBorrowThree()

    } catch (e) {
      // console.log("err =>", e)
    }
    // }

  }




  return (
    <Formik
      initialValues={fromInitialValues}
      enableReinitialize
    >
      {({ values, errors, touched, setFieldValue, handleBlur, handleChange }) => {

        async function getYearForSelect(e) {
          let postData = new FormData()
          postData.append("meetingNo", e.target.value)
          // console.log("meetingNo", e.target.value)
          try {
            let res = await fetch("api/ProposalBorrow/getMeetingYearSelect", {
              method: "POST",
              body: postData
            })
            let resJson = await res.json()
            setMeetingYearSelect(resJson.dataenum)
          } catch (e) {
            // console.log("err", e)
          }
        }
        return (
          <Container>
            {!loading ? (
              <>
                <Modal
                  isOpen={modalRecordBorrow}
                  onRequestClose={ToggleModalRecordBorrow}
                  style={myCustomStyles}
                >
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <h3 className="w-100" style={{ color: "#0E527E", maxWidth: "960px", width: "100%" }}>บันทึกผลการพิจารณา</h3>
                    <CgClose onClick={ToggleModalRecordBorrow} className="style-iconmodal" />
                  </div>
                  <hr />
                  <Formik
                    initialValues={recordBorrowInititalValue}
                    validationSchema={recordBorrowValidationSchema}
                    onSubmit={recordBorrowOnsubmit}
                    enableReinitialize
                  >
                    {({ values, errors, touched, setFieldValue, handleBlur, handleChange, handleSubmit }) => {

                      // console.log("values", values);

                      return (
                        <Form autoComplete="off" className="px-5">
                          <div>
                            <FormGroup>
                              <h5>ข้อมูลผู้ขอกู้</h5>
                            </FormGroup>

                            <FormGroup>
                              เลขที่คำขอ :
                              <span className="mx-1 input-color">{selectDetailTrainClassId?.borrowNumber}</span>
                            </FormGroup>
                            <FormGroup>
                              ชื่อผู้ขอกู้ :
                              <span className="mx-1 input-color">{selectDetailTrainClassId?.employee}</span>
                            </FormGroup>
                            <FormGroup>
                              หลักสูตร (เดิม) :
                              <span className="mx-1 input-color">{selectDetailTrainClassId?.courseName}</span>
                            </FormGroup>

                            <FormGroup>
                              หลักสูตร (ใหม่) :
                              <span className="mx-1 input-color">{selectDetailTrainClassId?.trainCourseNewName}</span>
                            </FormGroup>
                          </div>
                          <FormGroup>
                            <Label>สถานะ</Label>
                            <Input
                              type="select"
                              name="approveStatus"
                              id="approveStatus"
                              className={`rounded-pill input-color text-center ${errors.approveStatus ? "input-error" : ""}`}
                              // className="rounded-pill input-color text-center"
                              onChange={(e) => {
                                handleChange(e)
                              }}
                              onBlur={handleBlur}
                              value={values.approveStatus}

                            >
                              <option defaultValue={"กรุณาเลือก"}>กรุณาเลือก</option>
                              {selectOption.map((item) => (
                                <option key={item.id} value={item.id}>{item.value}</option>
                              ))}
                            </Input>
                          </FormGroup>


                          <div className="d-flex justify-content-center align-items-center">
                            <button className="btn-blue w-25 mx-2" disabled={errors.approveStatus ? true : false}>บันทึก</button>
                            <button className="btn-red w-25 mx-2" onClick={() => ToggleModalRecordBorrow()}>ยกเลิก</button>
                          </div>
                        </Form>
                      )
                    }}


                  </Formik>

                </Modal>

                <div className="mb-2">
                  <Form
                    className=""
                    // onSubmit={handleSubmit}
                    autoComplete="off"
                  >
                    <FormGroup row>
                      <Label for="" sm={1}>
                        ครั้งที่
                      </Label>
                      <Col sm={3}>
                        <Input
                          name="meetingNo"
                          type="select"
                          className="text-center w-100 rounded-pill input-color"
                          onChange={(e) => {
                            handleChange(e)
                            getYearForSelect(e)
                            setMeetingNo(e.target.value)
                          }}
                          onBlur={handleBlur}
                          value={values.meetingNo}
                        >
                          <option defaultValue={"กรุณาเลือก"}>
                            กรุณาเลือก
                          </option>
                          {meetingNoSelect.map((item, k) => (
                            <option key={k} value={item.meetingNo}>
                              {item.meetingNo}
                            </option>
                          ))}
                        </Input>
                      </Col>
                      <Label for="" sm={1}>
                        ปี
                      </Label>
                      <Col sm={3}>
                        <Input
                          name="meetingYear"
                          type="select"
                          className="text-center w-100 rounded-pill input-color"
                          onChange={(e) => {
                            handleChange(e)
                            setMeetingYear(e.target.value)
                          }}
                          onBlur={handleBlur}
                          value={values.meetingYear}
                        >

                          <option defaultValue={"กรุณาเลือก"}>
                            กรุณาเลือก
                          </option>
                          {meetingYearSelect.map((year, i) => (
                            <option key={i} value={year.meetingYear}>
                              {year.meetingYear}
                            </option>
                          ))}
                        </Input>
                      </Col>
                      <Label for="" sm={1}>
                        วันที่
                      </Label>
                      <Col sm={3}>
                        <Field name="meetingDate">
                          {({ field, meta, form }) => {
                            return (
                              <DatePicker
                                selected={field.value ? new Date(field.value) : null}
                                locale="th-buddhist"
                                showIcon
                                calendarClassName="thai-buddhist"
                                dateFormat="dd MMMM yyyy"
                                value={ConvertDateToThaiBuddhist(field.value)}
                                isClearable={true}
                                placeholderText="กรุณาเลือก"
                                renderCustomHeader={RenderCustomHeader}
                                onChange={(date) => {
                                  form.setFieldValue(field.name, ConvertDateFormat(date))
                                  setMeetingDate(ConvertDateFormat(date))
                                }}
                                customInput={
                                  <Input
                                    type="text"
                                    className={
                                      touched.meetingDate && errors.meetingDate
                                        ? "input-error rounded-pill text-center input-color custom-placeholder"
                                        : "rounded-pill text-center input-color custom-placeholder"
                                    }
                                    value={ConvertDateToThaiBuddhist(field.value)}
                                    onChange={() => { }}
                                    onBlur={field.onBlur}
                                  />
                                }
                              />
                            )
                          }}
                        </Field>
                      </Col>

                    </FormGroup>
                  </Form>

                </div>
                <div className="d-flex justify-content-end align-items-center mt-3">
                  <div className="d-flex align-items-center ">
                    <span className="me-2">
                      แสดง {" "}
                    </span>

                    <Input className="input-color rounded-pill" type="select" value={pageSize} onChange={e => setPageSize(Number(e.target.value))}>
                      {
                        [5, 10, 25, 50, 75, 100].map(pageSize => (
                          <option key={pageSize} value={pageSize}>
                            {pageSize}
                          </option>
                        ))
                      }
                    </Input>
                    <span className="mx-2">{" "} รายการ {" "}</span>

                  </div>
                  {/* <SearchFilter search={globalFilter} setSearch={setGlobalFilter}/> */}
                </div>
                <div style={{ overflowX: "auto" }} className="mt-3">
                  <Table style={{ minWidth: "max-content", outline: "none" }} className="styled-table text-center" bordered {...getTableProps()}>
                    <thead className='styles-thead'>

                      {headerGroups.map((headerGroup) => {
                        return (
                          <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => {
                              return (
                                <th {...column.getHeaderProps()}>
                                  {column.render("Header")}
                                </th>
                              )

                            })}
                          </tr>
                        )
                      })}
                    </thead>


                    <tbody {...getTableBodyProps()}>
                      {rows.map((row, i) => {
                        prepareRow(row);
                        // console.log("row", row)
                        // console.log("pagesize", pageSize)
                        // console.log("data", data)
                        for (let j = 0; j < row.allCells.length; j++) {
                          let cell = row.allCells[j];
                          let currentBorrowNumberForCheck = rowSpanHeaders.find((x) => x.id === "borrowNumber");
                          let rowSpanHeader = rowSpanHeaders.find((x) => x.id === cell.column.id);
                          if (rowSpanHeader !== undefined) {

                            if (rowSpanHeader.topCellValue === null || rowSpanHeader.topCellValue !== cell.value) {
                              cell.isRowSpanned = false;
                              rowSpanHeader.topCellValue = cell.value;
                              rowSpanHeader.topCellIndex = i;
                              cell.rowSpan = 1;
                            } else {
                              if (rowSpanHeader.id !== "borrowNumber") {
                                if (currentBorrowNumberForCheck.topCellValue !== data[i !== 0 ? i - 1 : 0].borrowNumber) {
                                  cell.isRowSpanned = false;
                                  rowSpanHeader.topCellValue = cell.value;
                                  rowSpanHeader.topCellIndex = i;
                                  cell.rowSpan = 1;
                                } else {
                                  if (rowSpanHeader.id === "inOutTypeName" || rowSpanHeader.id === "occupationTrain" || rowSpanHeader.id === "classAmount") {
                                    // console.log("inOutTypeName")
                                    if (data[i].trainCourseId === data[i !== 0 ? i - 1 : 0].trainCourseId) {
                                      rows[rowSpanHeader.topCellIndex].allCells[j].rowSpan++;
                                      cell.isRowSpanned = true;
                                    } else if (rowSpanHeader.id === "registeredCapital") {
                                      rows[rowSpanHeader.topCellIndex].allCells[j].rowSpan++;
                                      cell.isRowSpanned = true;
                                    } else {
                                      cell.isRowSpanned = false;
                                      rowSpanHeader.topCellValue = cell.value;
                                      rowSpanHeader.topCellIndex = i;
                                      cell.rowSpan = 1;
                                    }
                                  } else {
                                    rows[rowSpanHeader.topCellIndex].allCells[j].rowSpan++;
                                    cell.isRowSpanned = true;
                                  }
                                }
                              } else {
                                rows[rowSpanHeader.topCellIndex].allCells[j].rowSpan++;
                                cell.isRowSpanned = true;
                              }
                            }
                          }


                        }
                        return null;
                      })}


                      {!page.length ? (
                        <>
                          <tr>
                            <td className="text-center" colSpan="13">ไม่มีข้อมูล</td>
                          </tr>

                        </>
                      ) : (
                        <>
                          {rows.map((row) => {
                            if (row.original.No > pageSize) {
                              return null
                            } else {
                              return (
                                <tr {...row.getRowProps()}>
                                  {row.cells.map((cell) => {
                                    if (cell.isRowSpanned) {
                                      return null;
                                    } else {
                                      return (
                                        <td rowSpan={cell.rowSpan} {...cell.getCellProps()}>
                                          {cell.render("Cell")}
                                        </td>
                                      );
                                    }

                                  })}
                                </tr>
                              );
                            }
                          })}
                        </>
                      )}

                    </tbody>
                  </Table>
                </div>
              </>
            ) : (<Loading />)}

          </Container>
        )
      }}
    </Formik>



  )

}